import React, {useState} from "react";
import Helmet from "react-helmet";
import {convertJsonToQueryString, formatDateTime, queryStringToJSON, reloadPage} from "../../../helpers/NewCaHelper";
import {RouteComponentProps} from "react-router-dom";
import InputWithLabel from "../../common/form/InputWithLabel";
import SearchButton from "../../common/button/SearchButton";
import GoToCreatePageButton from "../../common/button/GoToCreatePageButton";
import NewTable from "../../common/table/NewTable";
import {onDeleteAlert, onFailAction, onSuccessAction} from "../../../helpers/SwalCommon";
import TableActionButton from "../user/table/action-button/TableActionButton";
import withNavbar from "../../common/HOC/NavbarContainerHOC";
import AssetCategoryService from "../../../services/asset-category/AssetCategoryService";
import SelectBox from "../../common/form/SelectBox";

interface Props extends RouteComponentProps {
}

const TITLE = "Danh mục tài sản";

const AssetCategory: React.FC<Props> = props => {
    const [dataSearch, setDataSearch] = useState({ten: "", ma: "", loai: ""});

    const onSubmitSearchButton = e => {
        e.preventDefault();
        const search = queryStringToJSON(props.location.search);
        let raw = {};
        for (let key in search){
            if (key === 'raw'){
                raw['raw'] = search[key];
            }
        }
        const queryString = convertJsonToQueryString({...dataSearch, ...raw});
        props.history.push({
            search: queryString
        });
    };

    const onChangeDataSearchInput = e => {
        const name = e.target.name;
        const value = e.target.value;
        setDataSearch({...dataSearch, [name]: value});
    };

    const onChangeDataSearchLoai = (e) => {
        setDataSearch({...dataSearch, "loai": e});
    };

    const fetchDataFunction = async () => {
        const service = new AssetCategoryService();
        const queryString = queryStringToJSON(props.location.search);
        try {
            const result = await service.list({...dataSearch,...queryString});
            return result;
        } catch (error) {
            console.log(error);
            onFailAction();
        }
    };

    const onClickDeleteButton = id => {
        onDeleteAlert(async willDelete => {
            if (willDelete) {
                const service = new AssetCategoryService();
                const result = await service.delete(id);
                if (result && result.status === 200) {
                    onSuccessAction(
                        "Xóa bản ghi tài sản thành công!",
                        reloadPage(props.location, props.history)
                    );
                }
            }
        });
    };

    const onRenderActionColumn = (text, record, index) => {
        return (
            <TableActionButton
                onClickUpdate={() =>
                    props.history.push(`/danh-muc-tai-san/cap-nhat/${record.id}`)
                }
                onClickDelete={() => onClickDeleteButton(record.id)}
            />
        );
    };

    return (
        <div className="card">
            <Helmet>
                <title>{TITLE}</title>
            </Helmet>
            <h4 className="card-title1">{TITLE}</h4>
            <div className="card-body">
                <form onSubmit={onSubmitSearchButton} className="search-form-index">
                    <div className="input-group">
                        <InputWithLabel
                            name="ten"
                            wrapClass="col-md-4 form-group nopadding-left"
                            onChangeValue={onChangeDataSearchInput}
                            value={dataSearch.ten}
                            isRequired={false}
                            label={""}
                            placeholder={"Tên tài sản"}
                        />
                        <InputWithLabel
                            name="ma"
                            wrapClass="col-md-2 form-group nopadding-left"
                            onChangeValue={onChangeDataSearchInput}
                            value={dataSearch.ma}
                            isRequired={false}
                            label={""}
                            placeholder={"Mã tài sản"}
                        />
                        <SelectBox
                            name="loai"
                            options={{
                                1: "Tài sản tài liệu bán hàng",
                                2: "Tài sản quà tặng"
                            }}
                            label=""
                            wrappedClass="col-md-3 nopadding-left"
                            firstOptionLabel="Chọn loại tài sản"
                            onChange={onChangeDataSearchLoai}
                            value={dataSearch.loai}
                        />
                        <div className="col-md-3 form-group">
                            <SearchButton onClick={onSubmitSearchButton}/>
                            <GoToCreatePageButton toURL={`${props.match.url}/them-moi`}/>
                        </div>
                    </div>
                </form>
                <NewTable
                    columns={[
                        {title: "Tên", dataIndex: "name"},
                        {title: "Mã", dataIndex: "code"},
                        {
                            title: "Loại tài sản",
                            dataIndex: "type",
                            render: text =>
                                text === 1 ? "Tài sản tài liệu bán hàng" : "Tài sản quà tặng"
                        },
                        {
                            title: "Ngày tạo",
                            dataIndex: "created_at",
                            render: text => formatDateTime(text)
                        },

                        {
                            title: "Tác vụ",
                            render: onRenderActionColumn
                        }
                    ]}
                    onFetchData={() => fetchDataFunction()}
                />
            </div>
        </div>
    );
};

export default withNavbar()(AssetCategory);
